// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar[data-v-ebb1a72a]{width:64px;height:64px}", "",{"version":3,"sources":["webpack://./src/components/molecules/StylistAvatar.vue"],"names":[],"mappings":"AAEA,yBACE,UAAA,CACA,WAAA","sourcesContent":["@import \"@/assets/scss/variables.scss\";\n\n.avatar {\n  width: 64px;\n  height: 64px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
